import React from "react";

import { OverflowTooltip } from "components";

import styles from "../matchReport.module.scss";
import tableStyles from "static/css/table.module.scss";

const stateColumn = () => ({
	Header: "State",
	accessor: "state",
	disableSortBy: true,
	classNameHeader: `${styles.tableHeader}`,
	Cell: ({ row }) => {
		let {
			values: { state },
		} = row;
		return (
			<OverflowTooltip onlyOnLaptop title={state}>
				<span className={tableStyles.contentHighlight}>{state}</span>
			</OverflowTooltip>
		);
	},
});

export default stateColumn;
